import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { deliverables } from '../../data/content';
export function Deliverables() {
  return <section className="w-full bg-white px-5 py-14 sm:py-20" data-id="element-99" data-mp="106g69hnyb6i8">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-100" data-mp="mejkrwgsfuut">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink-900 sm:text-[34px]" data-id="element-101" data-mp="mbxee05mvle6">
          📲 What will you receive immediately after purchasing?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-ink-900/60 sm:text-base" data-id="element-102" data-mp="1e33h8ocqnx75">
          You are not buying another resource to leave sitting on your computer. You are getting a
          complete clinical route designed to turn uncertainty into clear decisions from your very
          first patient.
        </p>

        <ul className="mt-10 grid gap-4 lg:grid-cols-3 lg:gap-5" data-id="element-103" data-mp="3ptfh5t6ju27q">
          {deliverables.map(item => <li key={item.title} className="flex flex-col rounded-2xl border border-bone-200 bg-bone-50 p-5 sm:p-6" data-id="element-104" data-mp="3uubjw3f5zibk">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-105" data-mp="9fbetqkrgh45">
                {item.emoji}
              </span>
              <h3 className="mt-3 font-display text-[19px] font-bold leading-tight text-ink-900 sm:text-xl" data-id="element-106" data-mp="oclvrfg6af79">
                {item.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-ink-900/65 sm:text-[15px]" data-id="element-107" data-mp="jflqv7v27ihq">
                {item.text}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-xl text-center" data-id="element-108" data-mp="sdnqbiz5a32w">
          <p className="font-display text-[21px] font-bold leading-snug text-ink-900 sm:text-[26px]" data-id="element-109" data-mp="171s7ujmgo8k3">
            Because when you have a clear route…
          </p>
          <p className="mt-2 text-[15px] leading-relaxed text-ink-900/65 sm:text-base" data-id="element-110" data-mp="1g3i2dybn3nm3">
            every clinical decision stops being a question and starts becoming a structured process.
          </p>
        </div>

        <TransformCTA tone="light" headline="Start applying the Male Fertility Route in your practice today." data-id="element-111" data-mp="1j5mqmknqohzc" />
      </div>
    </section>;
}